import { render, staticRenderFns } from "./RedirectToQADialog.vue?vue&type=template&id=58d71dbe&scoped=true"
import script from "./RedirectToQADialog.vue?vue&type=script&lang=js"
export * from "./RedirectToQADialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d71dbe",
  null
  
)

export default component.exports